import React, { useState, createContext, useContext } from 'react';
interface User {
  id: string;
  name: string;
  phone: string;
  email: string;
}
interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  login: (phone: string, password: string) => Promise<void>;
  signup: (data: any) => Promise<void>;
  logout: () => void;
  forgotPassword: (phone: string) => Promise<void>;
  resetPassword: (otp: string, newPassword: string) => Promise<void>;
}
const AuthContext = createContext<AuthContextType | undefined>(undefined);
export const AuthProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [user, setUser] = useState<User | null>(null);
  // Mock implementation for demo purposes
  const login = async (phone: string, password: string) => {
    // In a real app, this would call an API
    setUser({
      id: '123',
      name: 'Terry Crews',
      phone,
      email: 'terry@example.com'
    });
  };
  const signup = async (data: any) => {
    // In a real app, this would call an API
    setUser({
      id: '123',
      name: data.name,
      phone: data.phone,
      email: data.email
    });
  };
  const logout = () => {
    setUser(null);
  };
  const forgotPassword = async (phone: string) => {
    // In a real app, this would call an API
    console.log('Password reset requested for', phone);
  };
  const resetPassword = async (otp: string, newPassword: string) => {
    // In a real app, this would call an API
    console.log('Password reset with OTP', otp);
  };
  return <AuthContext.Provider value={{
    user,
    isAuthenticated: !!user,
    login,
    signup,
    logout,
    forgotPassword,
    resetPassword
  }} data-id="element-193">
      {children}
    </AuthContext.Provider>;
};
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};